import { createAsyncThunk } from "@reduxjs/toolkit"
import { formDataPost, get, post } from "helpers/api_helper"
import {
  GET_ALL_BOOKINGS,
  GET_BOOKING_DETAILS,
  UPDATE_BOOKING_STATUS,
  UPDATE_PAYMENT_CONTRACT_OR_LETTER,
  UPLOAD_DEED_DOCUMENTS,
} from "helpers/url_helper"

export const getAllBookings = createAsyncThunk(
  GET_ALL_BOOKINGS,
  async payload => {
    const response = await post(GET_ALL_BOOKINGS, payload)
    return response
  }
)

export const updateBookingStatus = createAsyncThunk(
  UPDATE_BOOKING_STATUS,
  async payload => {
    const response = await post(UPDATE_BOOKING_STATUS, payload)
    return response
  }
)

export const uploadContract = createAsyncThunk(
  UPDATE_PAYMENT_CONTRACT_OR_LETTER,
  async ({ formData, bookingId }) => {
    const response = await formDataPost(
      UPDATE_PAYMENT_CONTRACT_OR_LETTER,
      formData
    )
    return { response, bookingId }
  }
)

export const uploadDeliveryLetter = createAsyncThunk(
  `UPDATE_PAYMENT_CONTRACT_OR_LETTER`,
  async ({ formData, bookingId }) => {
    const response = await formDataPost(
      UPDATE_PAYMENT_CONTRACT_OR_LETTER,
      formData
    )
    return { response, bookingId }
  }
)

export const uploadDeedDocuments = createAsyncThunk(
  UPLOAD_DEED_DOCUMENTS,
  async ({ formData, bookingId }) => {
    const response = await formDataPost(
      UPLOAD_DEED_DOCUMENTS,
      formData
    )
    return { response, bookingId }
  }
)

export const getBookingDetails = createAsyncThunk(
  GET_BOOKING_DETAILS,
  async bookingId => {
    const response = await get(`${GET_BOOKING_DETAILS}/${bookingId}`)
    return response
  }
)
